/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useState, useRef, useEffect } from 'react';
import { Dialog, RadioGroup, Transition } from '@headlessui/react';
import { CheckIcon, XCircleIcon } from '@heroicons/react/outline';
import { ExclamationCircleIcon } from '@heroicons/react/outline';
import {
  CheckCircleIcon,
  CollectionIcon,
  EyeOffIcon,
  XIcon,
} from '@heroicons/react/solid';
import Button from '../Button';
import CollectionSocialBlogCard from '../SocialBlog/Cards/collection';

import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/analytics';
import UpgradeModal from '../NewModals/upgrade';
import CreateCollectionModal from '../NewModals/create-collection';

const proPlans = [
  'Premier',
  'premier',
  /*     "Hobby", */
  'Expert',
  'Pro',
  'Expert Lifetime',
];

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function AddToCollection({
  open,
  setOpen,
  galleryUsername,
  userID,
  productName,
  selected,
  setSelected,
}) {
  const cancelButtonRef = useRef();
  const [checked, setChecked] = useState(false);

  const [proModalOpen, setProModalOpen] = useState(false);

  const [proModalMSG, setProModalMSG] = useState(null);

  const [createCollectionModalOpen, setCreateCollectionModalOpen] =
    useState(false);
  const [activeCollection, setActiveCollection] = useState(null);

  const [collections, setCollections] = useState([]);

  useEffect(() => {
    galleryUsername && userID && getCollections();
  }, [galleryUsername, userID]);

  const getCollections = () => {
    var tempCollections = [];

    firebase
      .database()
      .ref('gallery')
      .child(galleryUsername)
      .child(userID)
      .child('collections')
      .once('value')
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach(function (childSnapshot) {
            if (childSnapshot.exists()) {
              tempCollections.push(childSnapshot.val().meta);
            }
          });

          setCollections(tempCollections);
        } else {
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const refreshCollections = () => {
    getCollections();
    closeCollectionCreateModal();
  };

  const createCollection = () => {
    if (proPlans.includes(productName)) {
      //is pro
      setActiveCollection(null);
      setCreateCollectionModalOpen(true);
    } else {
      if (collections.length > 0) {
        //has one collection, dont allow any more until upgrade
        setProModalOpen(true);
        setProModalMSG('Upgrade to Pro to create more than one collection');
      } else {
        //has no collections, allow to create one
        setActiveCollection(null);
        setCreateCollectionModalOpen(true);
      }
    }
  };

  const closeCollectionCreateModal = () => {
    setCreateCollectionModalOpen(false);
  };

  return (
    <Transition.Root
      initialFocus={cancelButtonRef}
      static
      show={open}
      as={Fragment}
    >
      <Dialog
        as="div"
        static
        className="fixed inset-0 z-40 overflow-y-auto"
        open={open}
        onClose={setOpen}
      >
        <div className="flex min-h-screen items-center justify-center px-4 pt-4 pb-20 text-center font-sans antialiased sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:h-screen sm:align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="relative inline-block w-full transform overflow-hidden rounded-xl bg-white text-left align-bottom shadow-xl transition-all sm:my-8 sm:max-w-2xl sm:align-middle">
              <div className="flex w-full flex-row items-center justify-between bg-gray-100 pt-2 pb-0 pl-4 pr-2 text-gray-500">
                <p className="font-mono text-xs font-semibold uppercase">
                  Add to Collection
                </p>

                <button
                  onClick={() => setOpen(false)}
                  ref={cancelButtonRef}
                  className={
                    ' transform rounded-full bg-gray-200 p-1.5 text-gray-500 outline-none duration-200 hover:scale-105 hover:text-gray-900 hover:outline-none focus:outline-none active:scale-100'
                  }
                >
                  <XIcon className="h-4 w-4" />
                </button>
              </div>

              <div className="flex items-center justify-center bg-gray-100 p-1.5">
                <div
                  className={
                    'flex w-full flex-col items-start justify-start rounded-xl bg-white p-6'
                  }
                >
                  {/* <p className="text-sm font-sans font-semibold uppercase text-center tracking-tight text-gray-400">
                  New
                </p> */}

                  <div
                    className={
                      'rounded-full bg-gradient-to-br from-gray-300 to-gray-100 p-3 text-gray-500'
                    }
                  >
                    <CollectionIcon className="h-6 w-6" />
                  </div>

                  <div className={'mt-4 flex w-full flex-col space-y-4'}>
                    <div className={'flex w-full flex-col space-y-1'}>
                      <RadioGroup
                        value={selected}
                        onChange={setSelected}
                        className={'w-full'}
                      >
                        <div
                          className={
                            'flex w-full flex-col items-center justify-start space-y-2 sm:flex-row sm:justify-between sm:space-y-0'
                          }
                        >
                          <p
                            className={
                              'font-primary text-lg font-semibold text-gray-900'
                            }
                          >
                            Add to Collection
                          </p>
                          <Button
                            click={createCollection}
                            size={'small'}
                            variant={'secondary'}
                          >
                            Create a Collection
                          </Button>
                        </div>

                        <div className="mt-4 grid w-full grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-4">
                          <RadioGroup.Option
                            value={null}
                            key={'none'}
                            className={({ checked, active }) =>
                              classNames(
                                'relative flex flex-shrink-0 cursor-pointer overflow-hidden rounded-3xl bg-white shadow-sm focus:outline-none',
                              )
                            }
                          >
                            {({ checked, active }) => (
                              <>
                                <div className="flex h-32 w-full items-center justify-center overflow-hidden rounded-3xl bg-gray-200 font-medium text-gray-600">
                                  None
                                </div>

                                <CheckCircleIcon
                                  className={classNames(
                                    !checked ? 'invisible' : '',
                                    'absolute top-2 right-2 h-7 w-7 text-blue-500',
                                  )}
                                  aria-hidden="true"
                                />
                              </>
                            )}
                          </RadioGroup.Option>
                          {collections.map((collection) => (
                            <RadioGroup.Option
                              key={collection.slug}
                              value={collection}
                              className={({ checked, active }) =>
                                classNames(
                                  'relative flex flex-shrink-0 cursor-pointer overflow-hidden rounded-3xl bg-white shadow-sm focus:outline-none',
                                )
                              }
                            >
                              {({ checked, active }) => (
                                <>
                                  <div className="h-32 w-40 min-w-full overflow-hidden rounded-3xl">
                                    <CollectionSocialBlogCard
                                      type={'small'}
                                      noScale={true}
                                      creatorID={userID}
                                      edit={false}
                                      name={collection.title}
                                      slug={collection.slug}
                                      imageName={
                                        collection.image !== undefined
                                          ? collection.image.image
                                          : null
                                      }
                                    />
                                  </div>
                                  <CheckCircleIcon
                                    className={classNames(
                                      !checked ? 'invisible' : '',
                                      'absolute top-2 right-2 h-7 w-7 text-blue-500',
                                    )}
                                    aria-hidden="true"
                                  />
                                </>
                              )}
                            </RadioGroup.Option>
                          ))}
                        </div>
                      </RadioGroup>
                    </div>
                  </div>

                  <div className="mt-8 ml-auto flex flex-row items-end space-x-2">
                    <Button click={() => setOpen(false)} size={'small'}>
                      Done
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>

        <UpgradeModal
          msg={proModalMSG}
          isOpen={proModalOpen}
          setIsOpen={setProModalOpen}
        />
        <CreateCollectionModal
          open={createCollectionModalOpen}
          setOpen={() => closeCollectionCreateModal()}
          card={activeCollection}
          editing={activeCollection ? true : null}
          loggedInUserID={userID}
          refreshCards={() => refreshCollections()}
          userSlug={galleryUsername}
        />
      </Dialog>
    </Transition.Root>
  );
}
